import { configureStore } from '@reduxjs/toolkit'

import config from '@/config'

import middlewares from './middlewares'
import reducer from './reducer'

export type RootState = ReturnType<typeof reducer>

export type AppDispatch = ReturnType<typeof configureStore>['dispatch']

export default (state: RootState) => {
  const store = configureStore({
    devTools: config.env.app !== 'production',
    preloadedState: state,
    reducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ['@action/NOTIFICATION/CREATE'],
        },
      }).concat(middlewares),
  })

  if (import.meta.hot) {
    import.meta.hot.accept('./reducer', () => store.replaceReducer(reducer))
  }

  return store
}
